/**
 * The plan someone picked on the landing page (`/auth?plan=start|firma`),
 * kept for the tab so the billing page can preselect it when the trial
 * converts. Storing it changes nothing visible.
 */
import type { PlanId } from "@/lib/pricing/plans";

export const PLAN_INTENT_KEY = "zettl:plan-intent";

type Store = Pick<Storage, "getItem" | "setItem"> | null;

function session(): Store {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch {
    return null;
  }
}

export function parsePlanParam(value: string | null | undefined): PlanId | null {
  return value === "start" || value === "firma" ? value : null;
}

export function rememberPlanIntent(value: string | null | undefined, store: Store = session()) {
  const plan = parsePlanParam(value);
  if (!plan) return;
  try {
    store?.setItem(PLAN_INTENT_KEY, plan);
  } catch {
    // private mode or blocked storage: the preselection is a convenience only
  }
}

export function readPlanIntent(store: Store = session()): PlanId | null {
  try {
    return parsePlanParam(store?.getItem(PLAN_INTENT_KEY));
  } catch {
    return null;
  }
}
